import { ADD_PRODUCT, INCRESE_PRODUCT, ITEMS_LIST, EDIT_PRODUCT, SET_FILTERD_LIST, SET_USER_ORDER, SET_TRANSFER_MONEY,
  SET_ORDER_PERSON_TYPE, SET_PERSON_SEARCH, SET_PERSON_OPTIONS, SET_SELECTED_PERSON
 } from "./cart.type";

export const addProduct= product => ({
    type : ADD_PRODUCT,
    payload : product
})

export const editProduct= product => ({
    type : EDIT_PRODUCT,
    payload : product
})

export const increseProduct= product => ({
    type : INCRESE_PRODUCT,
    payload : product
})

export const addItemsList = itemsList => ({
    type : ITEMS_LIST,
    payload : itemsList.map(ele => ({ ...ele, quantaty : 1 }))
})

export const addFilterdList = itemsList => (
    {
    type : SET_FILTERD_LIST,
    payload : itemsList
}
)
export const setUserOrder = order => ({
    type: SET_USER_ORDER,
    payload: order
  });

  export const setOrderPersonType = (personType) => ({
    type: SET_ORDER_PERSON_TYPE,
    payload: personType,
  });
  
  export const setPersonSearch = (search) => ({
    type: SET_PERSON_SEARCH,
    payload: search,
  });
  
  export const setPersonOptions = (options) => ({
    type: SET_PERSON_OPTIONS,
    payload: options,
  });
  
  export const setSelectedPerson = (person) => ({
    type: SET_SELECTED_PERSON,
    payload: person,
  });
  
  
  export const setTransferMoney = data => ({
    type: SET_TRANSFER_MONEY,
    payload: data
  });
